import React from 'react'
import Headers from '../components/Headers'
import Footer from '../components/Footer'

const PrivacyPolicy = () => {
    return (
        <div className='w-full'>
            <Headers />
            <div className='w-[85%] mx-auto py-16'>
                <div className='bg-white rounded-lg p-8'>
                    <h1 className='text-3xl font-bold mb-2 text-gray-900'>OMAH Privacy Policy</h1>
                    <p className='mb-8 text-gray-500 text-sm'>Last updated: April 2026</p>

                    <p className='mb-8 text-gray-700'>At OMAH, we are committed to protecting your privacy and handling your data securely and transparently.</p>

                    <div className='space-y-8 text-gray-700'>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>1. Information We Collect</h2>
                            <p className='mb-3'>We may collect:</p>
                            <ul className='list-disc pl-6 space-y-2'>
                                <li>Personal details (name, email, phone number)</li>
                                <li>Transaction and payment details (via licensed partners)</li>
                                <li>Delivery information (address, orders)</li>
                                <li>Device and usage data</li>
                                <li>Messages between buyers and sellers</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>2. How We Use Your Information</h2>
                            <p className='mb-3'>We use your data to:</p>
                            <ul className='list-disc pl-6 space-y-2'>
                                <li>Manage your account</li>
                                <li>Process secure transactions</li>
                                <li>Enable buyer–seller communication</li>
                                <li>Improve platform performance</li>
                                <li>Prevent fraud and ensure security</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>3. Payments & Escrow</h2>
                            <p>OMAH does not hold funds directly. Payments are processed securely through licensed providers like <strong>Flutterwave</strong>, which manage escrow and transaction security. Your financial data is governed by their respective privacy and security policies.</p>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>4. Information Sharing</h2>
                            <p className='mb-3'>We do not sell your data. We only share it:</p>
                            <ul className='list-disc pl-6 space-y-2'>
                                <li>With payment partners (for transaction processing)</li>
                                <li>Between buyers and sellers (only what is necessary to fulfil orders)</li>
                                <li>When required by law or for legitimate security reasons</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>5. Data Security</h2>
                            <p>We use industry-standard security measures to protect your data. However, no system is completely immune to risk — users are also responsible for keeping their account credentials safe and not sharing login details with others.</p>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>6. Your Rights</h2>
                            <p className='mb-3'>You have the right to:</p>
                            <ul className='list-disc pl-6 space-y-2'>
                                <li>Access or update your personal data at any time via your account settings</li>
                                <li>Request permanent account deletion</li>
                                <li>Report any privacy concerns to our support team</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>7. Policy Updates</h2>
                            <p>This policy may be updated from time to time to reflect changes in our practices or legal requirements. Users will be notified of any major changes through the platform.</p>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>8. Contact</h2>
                            <p>For any privacy-related questions or concerns, reach us via the <strong>Help & Support</strong> section in your dashboard or through official OMAH support channels.</p>
                        </section>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default PrivacyPolicy
